import React from 'react';
import PropTypes from 'prop-types';
import AuthorInput from '../../Framework/Components/Form/AuthorInput';
import BlockStyledEditor from '../../Framework/Components/Form/BlockStyledEditor';
import DateTime from '../../Framework/Components/Form/DateTime';
import Form from '../../Framework/Components/Form/Form';
import TagInput from '../../Framework/Components/Form/TagInput';
import TextArea from '../../Framework/Components/Form/TextArea';
import TextInput from '../../Framework/Components/Form/TextInput';
import Toggle from '../../Framework/Components/Form/Toggle';
import Image from '../../Framework/Components/Image/Image';

import Grid, { GridLeft, GridRight } from '../../Framework/Layouts/Grid';
import EntityUrlText from '../Products/EntityUrlText';
import routes from '../../Routes/routes';
import PreviewButton from './PreviewButton';
import DiscardDraftButton from '../../Framework/Pages/Article/DiscardDraftButton';
import style from '../../../scss/components/buttons/button.module.scss';
import ShareArticle from '../../Framework/Pages/Article/ShareArticle';
import CategoryInput from '../../Framework/Components/Form/CategoryInput';
import ArticleStatusText from '../../Framework/Components/Article/ArticleStatusText';
import PublishingTimer from '../../Framework/Components/Article/PublishingTimer';

const ArticleForm = ({ entity, ...props }) => {
    const frontendUrl = import.meta.env.VITE_FRONTEND_URL;
    return (
        <Form {...props}>
            <Grid>
                <GridLeft>
                    <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                        <EntityUrlText
                            path={routes.article}
                            buttonText="Article"
                        />
                        <ArticleStatusText />

                        <div className={style.magazineButtonActions}>
                            <DiscardDraftButton />
                            <PreviewButton />
                        </div>
                    </div>
                    <TextInput name="title" />
                    <TextInput name="seo_title" lockIfNotDraft maxLength={60} />
                    <TextInput
                        name="slug"
                        prefix={`${frontendUrl}magazine/`}
                        slugify
                        lockIfNotDraft
                    />
                    <Image name="image" limit={1} isDetachable />
                    <TextArea name="lead" />
                    <BlockStyledEditor name="body" fullFeatureSet />
                </GridLeft>
                <GridRight>
                    <div className="flex flex-wrap justify-between gap-4 mb-4">
                        <div>
                            <Toggle name="is_active" />
                            <Toggle name="is_sponsored" />
                            <Toggle name="is_18_plus" />
                        </div>
                        <div>
                            <DateTime name="created_at" readOnly />
                            <DateTime name="published_at" readOnly />
                            <DateTime name="updated_at" readOnly />
                        </div>
                    </div>
                    <AuthorInput name="authors" />
                    <CategoryInput name="categories" type="article" />
                    <TagInput name="tags" />
                    <ShareArticle />
                    <PublishingTimer name="published_at" />
                </GridRight>
            </Grid>
        </Form>
    );
};

export default ArticleForm;

ArticleForm.propTypes = {
    entity: PropTypes.shape({
        is_draft: PropTypes.bool,
    }),
};

ArticleForm.defaultProps = {
    entity: null,
};
